export const MINI_DETAIL_STAND_TIME = 500;
export const TRANSITION_TIME = 0.3;
